import { useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { IoCheckmarkCircleOutline, IoCloseCircleOutline, IoMailOutline } from "react-icons/io5";
import { useVerifyEmail } from "../services/AuthService";
import "./EmailVerification.scss";

export default function EmailVerification() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");

  const { data, isLoading, isError, error } = useVerifyEmail(token);

  // Bei erfolgreicher Verifizierung nach 3 Sekunden zur Login-Seite navigieren
  useEffect(() => {
    if (data?.success) {
      const timer = setTimeout(() => {
        navigate("/");
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [data?.success, navigate]);

  return (
    <div className="email-verification-page">
      <div className="email-verification-page__card">
        {isLoading && (
          <>
            <div className="email-verification-page__spinner" />
            <h1 className="email-verification-page__title">
              E-Mail wird verifiziert...
            </h1>
            <p className="email-verification-page__subtitle">
              Bitte warten Sie einen Moment.
            </p>
          </>
        )}

        {!isLoading && data?.success && (
          <>
            <div className="email-verification-page__icon email-verification-page__icon--success">
              <IoCheckmarkCircleOutline />
            </div>
            <h1 className="email-verification-page__title">
              E-Mail erfolgreich bestaetigt!
            </h1>
            <p className="email-verification-page__subtitle">
              {data.message ||
                "Ihre E-Mail-Adresse wurde erfolgreich verifiziert."}
            </p>
            {data.userName && (
              <p className="email-verification-page__info">
                Willkommen, <strong>{data.userName}</strong>!
              </p>
            )}
            <p className="email-verification-page__hint">
              Sie werden in wenigen Sekunden zur Startseite weitergeleitet.
            </p>
            <Link
              to="/"
              className="email-verification-page__btn email-verification-page__btn--primary"
            >
              Jetzt einloggen
            </Link>
          </>
        )}

        {!isLoading && (isError || (data && !data.success)) && (
          <>
            <div className="email-verification-page__icon email-verification-page__icon--error">
              <IoCloseCircleOutline />
            </div>
            <h1 className="email-verification-page__title">
              Verifizierung fehlgeschlagen
            </h1>
            <p className="email-verification-page__subtitle">
              {data?.message ||
                (error as Error)?.message ||
                "Der Verifizierungs-Link ist ungueltig oder abgelaufen."}
            </p>
            <div className="email-verification-page__hint-box">
              <IoMailOutline />
              <span>
                Falls die E-Mail nicht mehr auffindbar ist, koennen Sie sich
                einfach erneut registrieren oder beim Login eine neue
                Verifizierungs-E-Mail anfordern.
              </span>
            </div>
            <div className="email-verification-page__actions">
              <Link
                to="/"
                className="email-verification-page__btn email-verification-page__btn--primary"
              >
                Zur Startseite
              </Link>
            </div>
          </>
        )}

        {!token && !isLoading && (
          <>
            <div className="email-verification-page__icon email-verification-page__icon--error">
              <IoCloseCircleOutline />
            </div>
            <h1 className="email-verification-page__title">
              Kein Verifizierungs-Token
            </h1>
            <p className="email-verification-page__subtitle">
              Es wurde kein Token in der URL gefunden. Bitte klicken Sie auf
              den Link in der Verifizierungs-E-Mail.
            </p>
            <Link
              to="/"
              className="email-verification-page__btn email-verification-page__btn--primary"
            >
              Zur Startseite
            </Link>
          </>
        )}
      </div>
    </div>
  );
}